import { Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { useState } from "react";
import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "react-query";
import { useNavigate } from "react-router-dom";
import { Lists } from "../../components/common/Lists";
import TableComponent from "../../components/common/Tables";
import { useAppDispatch } from "../../hooks/hooks";
import { useGetTeacherRequiredDocumentsQuery } from "../../hooks/useGetTeacherRequiredDocumentsQuery";
import { routes } from "../../routes";
import { Key_teacherRequiredDocuments } from "../../utils/constants";
import { updateTeacherRequiredDocument } from "../../services/school/teacher/updateTeacherRequiredDocument";
import { RulesDocumentTeacherType } from "../../types/Teacher";
import { setUpdateTeacherRequiredDocumentData } from "../../redux/slices/school/teacherRequiredDocument";


const columnNamesMap: { [key: string]: string } = {
    description: 'Documento',
};
export const TeacherRequiredDocuments = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const queryClient = useQueryClient();
    const { data, status } = useGetTeacherRequiredDocumentsQuery({ PageNumber: currentPage, PageSize: 400 });

    const mutationUpdateTeacherRequiredDocument = useMutation(updateTeacherRequiredDocument, {
        onSuccess: () => {
            queryClient.invalidateQueries(Key_teacherRequiredDocuments);
            toast.success('Tipo de documento apagado');
        },
        onError: () => {
            toast.error("Erro ao apagar tipo de documento.")
        }
    });

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };
    const handleClickCreate = (event: any): void => {
        navigate(routes.createTeacherRequiredDocument)
    }
    const handleEdit = (TeacherRequiredDocument: RulesDocumentTeacherType) => {
        dispatch(setUpdateTeacherRequiredDocumentData(TeacherRequiredDocument));
        navigate(routes.updateTeacherRequiredDocument)
    };
    const handleDelete = (TeacherRequiredDocument: RulesDocumentTeacherType) => {
        TeacherRequiredDocument.status = false;
        mutationUpdateTeacherRequiredDocument.mutateAsync(TeacherRequiredDocument)
    };

    const options = data?.items.map((TeacherRequiredDocument: RulesDocumentTeacherType) => [
        {
            label: 'Editar',
            onClick: (TeacherRequiredDocument: RulesDocumentTeacherType) => handleEdit(TeacherRequiredDocument),
            icon: <Pencil1Icon />
        },
        {
            label: 'Excluir',
            onClick: (TeacherRequiredDocument: RulesDocumentTeacherType) => handleDelete(TeacherRequiredDocument),
            icon: <TrashIcon />
        }
    ]) || [];

    return (
        <Lists status={status}
            TableComponent={
                () =>
                    <TableComponent
                        columns={['description']}
                        items={data?.items}
                        options={options}
                        columnNamesMap={columnNamesMap}
                        totalPages={data?.totalPages || 1}
                        currentPage={currentPage}
                        onPageChange={handlePageChange} />
            }
            handleClickCreate={handleClickCreate} />
    );
}